import { render } from "./Received.vue?vue&type=template&id=5a237b4e&scoped=true"
import script from "./Received.vue?vue&type=script&lang=js"
export * from "./Received.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a237b4e"]])

export default __exports__